import * as angular from "angular";
import {IController} from "angular";

export class selfPickupStatusTagCtrl implements IController {

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.self-pickups')
  .component('selfPickupStatusTag', {
    bindings: {
      status: '<',
      onChange: '&'
    },
    template: require('./self-pickup-status-tag.html').default,
    controller: selfPickupStatusTagCtrl
  });
